// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__v55Fs","withBackground":"styles_withBackground__IRvJr","icon":"styles_icon__7wz6e"};